import { Button, Col, Form, Grid, Layout, Popconfirm, Select, theme, Typography } from 'antd';
import { PaymentContainer } from '../../../../../components/payment.container';
import { SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFieldsFragment, Entity, SendReportCaseV1CaseDetailsApplicationInput } from '../../../../../../../../generated';
import { CertificationByApplicantLegalDisclaimer } from '../../../../../components/certification-by-applicant-legal-disclaimer';

interface CreateProps {
  formLoading: boolean;
  onWithdrawRequest: () => Promise<void>;
  serviceFee: number;
  entities: Entity[];
  applicantCredentialCases: SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFieldsFragment[];
  onSubmit: (values: SendReportCaseV1CaseDetailsApplicationInput) => Promise<void>;
}

export const Create: React.FC<CreateProps> = (props) => {
  const [form] = Form.useForm();
  const handleSubmitRequest = () => {
    form.validateFields().then(async (values) => {
      const isAttestationComplete = values.certificationAgreement && values.termAcknowledgement && values.informationAuthorization && values.isAttestationComplete;
      await props.onSubmit({
        credential: values.credentialToSendId,
        destination: values.sendDestinationId,
        isAttestationComplete: isAttestationComplete
      });
    });
  };

  const {
    token: { colorBgContainer, borderRadiusLG }
  } = theme.useToken();

  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;
  return (
    <Layout className="flex flex-col min-h-screen">
      <div
        style={{
          background: colorBgContainer,
          width: isMobile ? '100%' : '70%',
          minWidth: 280,
          padding: isMobile ? '48px 0px 0px 0px' : '48px',
          borderRadius: borderRadiusLG,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'baseline'
        }}
      >
        <Form
          form={form}
          style={{ width: isMobile ? '100%' : '50%' }}
          layout="vertical"
          initialValues={{
            credentialToSend: undefined,
            sendDestination: undefined,
            isAttestationComplete: false
          }}
        >
          <Form.Item
            rules={[
              {
                required: true,
                message: 'Please select a Credential.'
              }
            ]}
            name={'credentialToSendId'}
            label="Credential for which you want to send a Verification Status Report:"
          >
            <Select placeholder="Select Credential" style={{ width: '100%' }}>
              {props.applicantCredentialCases
                .map((credentialCase) => (
                  <Select.Option key={credentialCase.id} value={credentialCase.id}>
                    {`${credentialCase.caseDetails?.application?.issuingInstitutionName} - ${credentialCase.caseDetails?.application?.credentialTitle}`}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: 'Please select a Destination.'
              }
            ]}
            name={'sendDestinationId'}
            label="Recipient for the Verification Status Report:"
          >
            <Select placeholder="Select Destination" style={{ width: '100%' }}>
              {props.entities
                ?.filter((entity) => entity.isClient)
                .map((entity) => (
                  <Select.Option key={entity.id} value={entity.id}>
                    {entity.entityName}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="isAttestationComplete"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms')))
              }
            ]}
          ></Form.Item>
          <CertificationByApplicantLegalDisclaimer />
          <PaymentContainer isDraftMode={true} />
          <br/>
            <Typography.Text strong> Your credit card will be charged US${props.serviceFee} when you submit your request.</Typography.Text>
        </Form>
      </div>
      <br />
      <div className={`flex items-center ${isMobile ? 'justify-center' : 'justify-end'} gap-4 w-full pb-[5.5rem]`}>
        <Col>
          <Popconfirm title="Are you sure? Your entries on this page will be deleted." onConfirm={async () => await props.onWithdrawRequest()}>
            <Button danger disabled={props.formLoading}>
              Withdraw Request
            </Button>
          </Popconfirm>
        </Col>

        <Popconfirm title="Are you sure?" onConfirm={handleSubmitRequest}>
          <Button type="primary" loading={props.formLoading}>
            Submit Request
          </Button>
        </Popconfirm>
      </div>
    </Layout>
  );
};
